export default "__VITE_ASSET__Vg21ZaeD__"